import React, {Component} from 'react';
import translations from 'decorators/translations.js';
import {StyleRoot} from 'radium';
import Helmet from 'react-helmet';
import {connect} from 'react-redux';
import { Cookies } from 'utils/index.js';

import {
    load as loadProfile
} from 'redux/modules/userProfile.js';

import {
    load as loadTranslations
} from 'redux/modules/translations.js';

import Navigation from './Navigation/Navigation.js';
import Loading from './Loading/Loading.jsx';
import ErrorHandler from './ErrorHandler/ErrorHandler.js';
import ReadOnlyBanner from 'components/ReadOnlyBanner/ReadOnlyBanner.js';
import {
    Notificator
} from 'components';

import './Application.css';

let deferredShow;

export const LOGIN_URL = process.env.REACT_APP_API_URL + '/auth/login'
export const LOGOUT_URL = process.env.REACT_APP_API_URL + '/auth/logout'
class Application extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadingUserProfile: true,
            showLoadingIndicator: false
        };
    }

    componentWillMount() {
        deferredShow = setTimeout(() => {
            this.setState({showLoadingIndicator: true});
        }, 1000);

        this.props.loadProfile().then((response) => {
            if (isUnauthorized(response)) {
                return window.location = LOGIN_URL;
            } else if (isInternalServerError(response)) {
                // TODO: move to error page with retry link?
                this.setState({loadingUserProfile: false});
                return window.location = LOGIN_URL;
            } else {
                this.setState({loadingUserProfile: false});
            }
            const langMapper = {
                finland: 'fi',
                industria: 'fi_industria',
                norway: 'no',
                sweden: 'sv',
                denmark: 'da',
                germany: 'de',
                lithuania: 'lt',
                estonia: 'et',
            };
            const userProfile = this.props.profile.user || {};
            const defaultSalesArea = userProfile.salesAreas && userProfile.salesAreas.length > 0 ? userProfile.salesAreas[0] : false;
            const defaultCountryLanguage = langMapper[defaultSalesArea];
            const language = this.props.translations.language || Cookies.getItem('selectedLanguage') || defaultCountryLanguage || 'en';
            this.props.loadTranslations(language);
            clearTimeout(deferredShow);
        });
    }


    render() {
        if (this.state.loadingUserProfile) {
            if (this.state.showLoadingIndicator) {
                return (
                    <Loading/>
                );
            }
            // For the first 1000 milliseconds, show white page
            return null;
        }
        return (
            <StyleRoot>
                <ErrorHandler/>
                <Helmet titleTemplate="%s - Caverion Contract tool"/>
                <Navigation client={this.props.client.client} user={this.props.profile.user} />
                { this.props.profile.user && this.props.profile.user.readOnly && <ReadOnlyBanner /> }
                {this.props.children}
                <Notificator />
            </StyleRoot>
        );
    }
}

function isInternalServerError(response) {
    return response && response.error && response.error.statusCode === 500;
}

function isUnauthorized(response) {
    return response && response.error && (response.error.status === 403);
}

function mapStateToProps(state) {
    return {
        profile: state.userProfile,
        client: state.client,
        translations: state.translations,
        cookies: state.cookies
    };
}
function mapDispatchToProps(dispatch) {
    return {
        loadProfile: () => {
            return dispatch(loadProfile());
        },
        loadTranslations: (language) => {
            return dispatch(loadTranslations(language, true));
        }
    }
}

const connector = connect(mapStateToProps, mapDispatchToProps);

export default translations(connector(Application));